import { NavLink } from "react-router-dom";

import OutputCombo from "components/OutputCombo";
import GreenBars from "components/svg/GreenBars";

export default function ElectricityConsumption({ electricityData, showBars }: any) {
  const { consumedByGrowers = 0, importedFromGrid = 0, eurosConsumedByGrowers = 0, eurosImportedFromGrid = 0 } = electricityData ?? {};

  return (
    <div className="output-card">
      {showBars ? (
        <NavLink className="absolute top-6 right-3" to={`${process.env.PUBLIC_URL}/electricity-data`}>
          <GreenBars />
        </NavLink>
      ) : null}
      <div className="flex-shrink-0 mb-3 pt-7 px-7 font-bold">Electricity Consumption</div>
      <div className="flex flex-col justify-between px-7">
        <OutputCombo
          title="Consumed From Growers"
          info="Some Info about"
          bigValue={`${(consumedByGrowers / 10 ** 6).toFixed(2)} <sup class="text-xs">mW</sup>`}
          smallValue={eurosConsumedByGrowers.toLocaleString("en-GB", { style: "currency", currency: "EUR" })}
          className="mb-2"
          hasDivide
        />
        <OutputCombo
          title="Consumed From Grid"
          info="Some Info about"
          bigValue={`${(importedFromGrid / 10 ** 6).toFixed(2)} <sup class="text-xs">mW</sup>`}
          smallValue={eurosImportedFromGrid.toLocaleString("en-GB", { style: "currency", currency: "EUR" })}
          className="mt-3"
          hasDivide
        />
      </div>
      <div className="px-7 py-5 mt-5 bg-slate-100 border-t border-gray-100 font-semibold">
        <h3 className="text-xs mb-2">Total consumption</h3>
        <div className="flex justify-between text-blue-600">
          <div className="text-4xl font-['Avenir-Bold'] tracking-tighter">{((consumedByGrowers + importedFromGrid) / 10 ** 6).toFixed(2)}  <sup className="text-sm -top-4">mW</sup></div>
          <div className="text-sm font-sans">
            {(eurosConsumedByGrowers + eurosImportedFromGrid).toLocaleString("en-GB", { style: "currency", currency: "EUR" })}
          </div>
        </div>
      </div>
    </div>
  );
}
